import { useState } from 'react';
import usePlatformBrandKits from '@/hooks/usePlatformBrandKits';
import { MediaPickerTab, UseMediaPickerStateReturn } from '@/Pages/BrandKit/types';

export function useMediaPickerState(): UseMediaPickerStateReturn {
  const [activeTab, setActiveTab] = useState<MediaPickerTab>('uploads');
  const { brandKits, selectedBrandKitId: globalKitId } = usePlatformBrandKits();
  const [localBrandKitId, setActiveBrandKitId] = useState<string | undefined>();

  const activeBrandKitId = localBrandKitId ?? globalKitId;
  const activeKit = brandKits.find(kit => kit.id === activeBrandKitId) ?? brandKits[0];

  return { activeTab, setActiveTab, activeBrandKitId, setActiveBrandKitId, brandKits, activeKit };
}
